var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRitardoMedio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_diii_839_7393)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#A1E430",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 3.25,
    width: 20.5,
    height: 20.5,
    rx: 10.25,
    stroke: "#A1E430",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_7393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7C14.2144 7 12.9577 7.38122 11.8888 8.09545C10.8199 8.80968 9.98676 9.82484 9.49479 11.0126C9.00282 12.2003 8.87409 13.5072 9.1249 14.7681C9.3757 16.029 9.99477 17.1872 10.9038 18.0962C11.8129 19.0052 12.971 19.6243 14.2319 19.8751C15.4928 20.1259 16.7997 19.9972 17.9874 19.5052C19.1752 19.0132 20.1903 18.1801 20.9046 17.1112C21.6188 16.0423 22 14.7856 22 13.5C21.9981 11.7767 21.3127 10.1244 20.0941 8.90586C18.8756 7.68728 17.2233 7.00186 15.5 7V7ZM16.0417 13.4345C16.0417 13.5263 16.0184 13.6166 15.974 13.697C15.9296 13.7773 15.8654 13.845 15.7876 13.8938L13.7076 15.1938C13.6472 15.2316 13.5799 15.2571 13.5095 15.2688C13.4392 15.2806 13.3673 15.2784 13.2978 15.2623C13.2284 15.2463 13.1627 15.2167 13.1047 15.1753C13.0467 15.1339 12.9974 15.0815 12.9596 15.021C12.9218 14.9605 12.8963 14.8932 12.8846 14.8229C12.8728 14.7526 12.875 14.6807 12.8911 14.6112C12.9071 14.5417 12.9367 14.4761 12.9781 14.4181C13.0195 14.36 13.0719 14.3107 13.1324 14.273L14.9583 13.1344V10.7917C14.9583 10.648 15.0154 10.5102 15.117 10.4087C15.2186 10.3071 15.3563 10.25 15.5 10.25C15.6437 10.25 15.7814 10.3071 15.883 10.4087C15.9846 10.5102 16.0417 10.648 16.0417 10.7917V13.4345Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_diii_839_7393",
    x: 0,
    y: 0,
    width: 31,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.545098 0 0 0 0 0.772549 0 0 0 0 0.6 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_839_7393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_839_7393",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.874597 0 0 0 0 0.932332 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_839_7393"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_839_7393",
    result: "effect3_innerShadow_839_7393"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.545098 0 0 0 0 0.772549 0 0 0 0 0.6 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_839_7393",
    result: "effect4_innerShadow_839_7393"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_7393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(9 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRitardoMedio);
export default __webpack_public_path__ + "static/media/ritardo_medio.2af1c84e8b67a735e5b225c567bb70e2.svg";
export { ForwardRef as ReactComponent };